import { ApiConfig } from "common/models";
import { buildEngApiUrl, buildSearchApiUrl } from "common/utils/api.util";
import {
  AnalyseDocumentsRequest,
  ResumeSpecAuditRequest,
  StartPackageRequest,
  TriggerSpecAuditRequest
} from "../models/knowledge-agent.model";

const ADMIN_CONTROLLER = "Admin";

export const knowledgeAgentConfig = {
  getAdminDocuments: (): ApiConfig => {
    return new ApiConfig(
      buildEngApiUrl(`${ADMIN_CONTROLLER}/Documents`),
      "POST",
      "hasDuplicate=false",
      {
        page: 1,
        size: 100,
        sort: "",
        dir: "",
        search: "",
        showDuplicates: false
      }
    );
  },

  analyseDocuments: (request: AnalyseDocumentsRequest): ApiConfig => {
    return new ApiConfig(
      buildEngApiUrl(`${ADMIN_CONTROLLER}/analyse`),
      "POST",
      "",
      request
    );
  },

  getAllReferenceStandards: (): ApiConfig => {
    return new ApiConfig(buildEngApiUrl("agent/get-all"), "GET");
  },

  uploadReferenceStandard: (file: File): ApiConfig => {
    const formData = new FormData();
    formData.append("file", file);
    return new ApiConfig(buildEngApiUrl("agent/upload"), "POST", "", formData);
  },

  triggerSpecAuditSession: (request: TriggerSpecAuditRequest): ApiConfig => {
    return new ApiConfig(
      buildEngApiUrl("agent/spec-audit-session/trigger"),
      "POST",
      "",
      request
    );
  },

  getSpecAuditSession: (sessionId: string): ApiConfig => {
    return new ApiConfig(
      buildEngApiUrl(`agent/spec-audit-session/${sessionId}`),
      "GET"
    );
  },

  getAllSpecAuditSessions: (): ApiConfig => {
    return new ApiConfig(
      buildEngApiUrl("agent/spec-audit-session/get-all"),
      "GET"
    );
  },

  resumeSpecAuditSession: (request: ResumeSpecAuditRequest): ApiConfig => {
    return new ApiConfig(
      buildSearchApiUrl("spec-audit/resume"),
      "POST",
      "",
      request
    );
  },

  startPackage: (request: StartPackageRequest): ApiConfig => {
    return new ApiConfig(
      buildSearchApiUrl("start-package"),
      "POST",
      "",
      request
    );
  }
};
